import { Grid, MenuItem, TextField } from "@mui/material";
import { forwardRef } from "react";
import type { IDynamicFieldProps } from "./types";
import { useAppSelector } from "../../redux";
import { selectText } from "../LanguageSelect/LanguageSelectSlice";

interface ICustomTextProps {
  feild: IDynamicFieldProps;
  error: boolean;
  err_msg: any;
  setcountry?(e: string): void;
  qa?: string;
}

export const CustomField = forwardRef((props: ICustomTextProps, ref: any) => {
  const { feild, error, err_msg } = props;
  const { size, name, label, type } = feild;
  const text = useAppSelector(selectText);
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  const render = (type: string) => {
    switch (type) {
      case "input": {
        return (
          <TextField
            variant="outlined"
            sx={{ direction: "ltr" }}
            fullWidth
            name={feild.name}
            rows={15}
            type={feild.type}
            inputRef={ref}
            label={label}
            helperText={error ? err_msg : ""}
            onKeyDown={handleKeyDown}
            {...props}
          />
        );
      }

      case "select": {
        if (name === "bank_country") {
          return (
            <TextField
              sx={{ direction: "ltr" }}
              variant="outlined"
              fullWidth
              select
              rows={15}
              type={feild.type}
              inputRef={ref}
              label={label}
              name={feild.name}
              helperText={error ? err_msg : ""}
              onKeyDown={handleKeyDown}
            >
              {(feild.values as string[])?.map((contry) => (
                <MenuItem key={contry} value={contry}>
                  {contry}
                </MenuItem>
              ))}
            </TextField>
          );
        }

        return (
          <TextField
            variant="outlined"
            sx={{ direction: "ltr" }}
            fullWidth
            select
            rows={15}
            name={feild.name}
            type={feild.type}
            inputRef={ref}
            label={label}
            helperText={error ? err_msg : ""}
            onKeyDown={handleKeyDown}
            {...props}
          >
            {(feild.values as string[])?.map((contry) => (
              <MenuItem key={contry} value={contry}>
                {contry}
              </MenuItem>
            ))}
          </TextField>
        );
      }
      default: {
        return <Grid>{text.oops}</Grid>;
      }
    }
  };

  return (
    <Grid item xl={size.xl} lg={size.lg} md={size.md} sm={size.sm} xs={size.xs}>
      {render(type)}
    </Grid>
  );
});
